export const isTestplane = () => {
    if (window && window.document && window.document.cookie) {
        const matches = global.document && document.cookie.match(/(?:^|; )e2e_testId=([^;]*)/);
        const testplane = matches ? matches[1] : undefined;

        return Boolean(testplane);
    }

    return false;
};
